import { Link } from "react-router-dom";

/**
 * HomeOverview — bloc de synthèse de la page d'accueil.
 * Présente la mission d'Aoria comme une organisation qui couvre
 * 6 axes : Enjeu, Outils, FAQ, Manifeste, Ressources, Partenaires, Livre blanc.
 * Chaque carte renvoie vers la page dédiée correspondante.
 */
const ITEMS = [
    {
        to: "/enjeu",
        num: "I",
        eyebrow: "Enjeux",
        title: "Accessibilité cognitive à l'ère de l'IA",
        body: "Le socle intellectuel : définition, constats, leviers et risques d'une nouvelle fracture cognitive.",
        cta: "Lire les enjeux",
    },
    {
        to: "/outils",
        num: "II",
        eyebrow: "Outils",
        title: "Des cas d'usage concrets, avec leurs limites",
        body: "Comprendre un document, simplifier une démarche, structurer ses idées, usages raisonnés des outils numériques et de l'IA.",
        cta: "Voir les outils",
    },
    {
        to: "/manifeste",
        num: "III",
        eyebrow: "Manifeste",
        title: "Deux idées que nous assumons",
        body: "L'IA est aussi un outil d'accessibilité cognitive. L'équité suppose parfois des outils différents.",
        cta: "Lire le manifeste",
    },
    {
        to: "/ressources",
        num: "IV",
        eyebrow: "Ressources",
        title: "Articles, guides, études et publications",
        body: "Des contenus en libre accès, publiés au fil de l'eau et enrichis progressivement.",
        cta: "Explorer les ressources",
    },
    {
        to: "/partenaires",
        num: "V",
        eyebrow: "Partenaires",
        title: "Construire avec l'enseignement, la recherche et le numérique",
        body: "Coopérations institutionnelles, scientifiques, associatives et industrielles autour de l'accessibilité cognitive.",
        cta: "Découvrir les partenariats",
    },
    {
        to: "/livre-blanc",
        num: "VI",
        eyebrow: "Livre blanc",
        title: "La version 1 est en préparation",
        body: "Un document de référence consacré aux enjeux de l'accessibilité cognitive à l'ère numérique.",
        cta: "Voir le projet éditorial",
    },
];

export default function HomeOverview() {
    return (
        <section
            data-testid="home-overview-section"
            id="le-projet"
            className="py-24 md:py-36 border-t border-[#E0E1DD]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
                    <div className="lg:col-span-3 reveal">
                        <div className="flex items-center gap-4">
                            <span
                                aria-hidden="true"
                                className="inline-block h-px w-9 bg-[#0D1B2A]/40"
                            />
                            <span className="eyebrow">Le projet</span>
                        </div>
                    </div>
                    <div className="lg:col-span-9">
                        <h2 className="reveal h2 text-4xl md:text-5xl lg:text-6xl text-[#0D1B2A] max-w-4xl">
                            Aoria construit{" "}
                            <span className="italic text-[#415A77]">
                                une plateforme de référence
                            </span>{" "}
                            sur l'accessibilité cognitive.
                        </h2>
                        <p className="reveal delay-1 mt-8 text-lg md:text-xl text-[#5C6B7D] max-w-3xl">
                            Une organisation qui produit des ressources, défend
                            des positions, et tisse des partenariats avec
                            l'enseignement, la recherche, le monde associatif et
                            les acteurs du numérique. Six entrées pour explorer
                            le projet.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {ITEMS.map((it, i) => (
                        <Link
                            key={it.to}
                            to={it.to}
                            data-testid={`home-card-${it.to.replace("/", "")}`}
                            className={`reveal delay-${(i % 4) + 1} card-aoria group`}
                        >
                            <div className="flex items-center justify-between mb-6">
                                <span className="editorial-num text-base">
                                    {it.num}
                                </span>
                                <span className="eyebrow text-[#778DA9]">
                                    {it.eyebrow}
                                </span>
                            </div>
                            <h3 className="h3 text-xl md:text-2xl text-[#0D1B2A] leading-snug">
                                {it.title}
                            </h3>
                            <p className="mt-4 text-[#5C6B7D] text-sm leading-relaxed flex-1">
                                {it.body}
                            </p>
                            <span className="mt-7 pt-5 border-t border-[#E0E1DD] text-sm text-[#0D1B2A] link-underline self-start">
                                {it.cta} →
                            </span>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
